{
  "familyName": "Pojtinger",
  "parents": [
    {
      "name": "Nette",
      "username": "@an.nette.pojtinger",
      "followLink": "https://www.instagram.com/an.nette.pojtinger/",
      "emailLink": "mailto:nette@pojtinger.com",
      "path": "/nette",
      "avatarLink": "https://cloud.pojtinger.com/apps/files_sharing/publicpreview/CzS9ikQ8pbSdpAw?file=/Nette.jpg&fileId=2090309&x=3456&y=2160&a=true&etag=afb0f18888fc9b901912d84ebc72fb38",
      "websiteLink": "https://netteart.com/",
      "websiteTitle": "NetteART"
    },
    {
      "name": "Michael",
      "username": "@michaelpojtinger",
      "followLink": "https://www.instagram.com/michaelpojtinger/",
      "emailLink": "mailto:michael@pojtinger.com",
      "path": "/michael",
      "avatarLink": "https://cloud.pojtinger.com/apps/files_sharing/publicpreview/CzS9ikQ8pbSdpAw?file=/Michael.jpg&fileId=2090306&x=3456&y=2160&a=true&etag=391f8f140fe6feb7f02512b7cbe95300"
    }
  ],
  "children": [
    {
      "name": "Toni",
      "username": "@toni.pojtinger",
      "followLink": "https://www.instagram.com/toni.pojtinger/",
      "emailLink": "mailto:toni@pojtinger.com",
      "path": "/toni",
      "avatarLink": "https://cloud.pojtinger.com/apps/files_sharing/publicpreview/CzS9ikQ8pbSdpAw?file=/Toni.jpg&fileId=2090312&x=3456&y=2160&a=true&etag=186e894efd5590f07aa1b58a9cd5457b"
    },
    {
      "name": "Luis",
      "username": "@luispojtinger",
      "followLink": "https://www.instagram.com/luispojtinger/",
      "emailLink": "mailto:luis@pojtinger.com",
      "path": "/luis",
      "avatarLink": "https://cloud.pojtinger.com/apps/files_sharing/publicpreview/CzS9ikQ8pbSdpAw?file=/Luis.jpg&fileId=2090303&x=3456&y=2160&a=true&etag=4cdba1fd229395b11bb30509ee31c0be"
    },
    {
      "name": "Felicitas",
      "username": "@pojntfx",
      "followLink": "https://felicitas.pojtinger.com/",
      "emailLink": "mailto:felicitas@pojtinger.com",
      "path": "/felicitas",
      "remoteLink": "https://felicitas.pojtinger.com/",
      "avatarLink": "https://github.com/pojntfx.png"
    }
  ]
}
